module.exports = __webpack_public_path__ + "static/img/Smaco-Logo-banner-NoBackground150.f52740d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Smaco-Logo-banner-NoBackground150.png
// module id = DOrB
// module chunks = 1